package net.frozenbit.games.soundgame.ui

import androidx.compose.animation.AnimatedContentScope
import androidx.compose.animation.SharedTransitionScope
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.components.JoinCode
import net.frozenbit.games.soundgame.components.PlayerTag
import net.frozenbit.games.soundgame.components.Prompt
import net.frozenbit.games.soundgame.components.QuarterArc
import net.frozenbit.games.soundgame.components.Scoring
import net.frozenbit.games.soundgame.components.SoundCreationBox
import net.frozenbit.games.soundgame.theme.Dimensions
import net.frozenbit.games.soundgame.theme.secondaryContainerLight
import net.frozenbit.games.soundgame.viewmodels.HostViewModel
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData

context(screenTransitions: AnimatedContentScope)

@Composable
fun SharedTransitionScope.HostWinnerPresentationScreen(
    joinCode: String,
    jury: PlayerTagData,
    entries: List<HostViewModel.HostUiState.WinnerPresentation.Entries>,
    promptText: String,
) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(Dimensions.Host.bigInnerPadding, Alignment.Top),
        ) {
            Prompt(
                promptText,
                modifier = Modifier.sharedElement(
                    rememberSharedContentState(key = "prompt"),
                    screenTransitions,
                )
            )
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceEvenly,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp)
            ) {
                entries.forEachIndexed { index, entry ->
                    val option = entry.creation
                    SoundCreationBox(
                        option,
                        modifier = Modifier
                            .weight(1f, fill = false)
                            .sharedElement(
                                rememberSharedContentState(key = "creation_$index"),
                                screenTransitions,
                            )
                    ) {
                        Scoring(entry.author, if (entry.revealPoints) entry.points else null)
                    }
                }
            }
        }
        QuarterArc(
            modifier = Modifier
                .align(Alignment.BottomStart)
        )
        Box(
            modifier = Modifier
                .align(Alignment.BottomStart)
                .padding(16.dp)
        ) {
            PlayerTag(
                jury,
                modifier = Modifier
                    .align(Alignment.BottomStart)
            )
        }
        JoinCode(
            joinCode,
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(16.dp)
        )
    }
}